import {createActions} from 'reduxsauce';

export const { Types: UserAccountTypes, Creators: UserAccountActionCreators} = createActions ({
    activateStart: ['activationKey'],
    activateSuccess: ['user'],
    activateFailure: ['error']
});